var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { Magic } from 'magic-sdk';
import { useState } from 'react';
import { appEnv } from '../../../env';
import { sleep } from '../../../utils/async';
export function useMagicLinkContext() {
    var t = useI18n().t;
    var _a = useState(), magic = _a[0], setMagic = _a[1];
    var _b = useState(false), isMagicLoggedIn = _b[0], setIsMagicLoggedIn = _b[1];
    var _c = useState(false), isMagicLoggedInWithUser = _c[0], setIsMagicLoggedInWithUser = _c[1];
    var _d = useState(false), showOtpDialog = _d[0], setShowOtpDialog = _d[1];
    var _e = useState(false), showDeviceMessage = _e[0], setShowDeviceMessage = _e[1];
    var _f = useState(false), loading = _f[0], setLoading = _f[1];
    var _g = useState(undefined), errorMessage = _g[0], setErrorMessage = _g[1];
    function reconnectMagicLink(userAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var _magic, isLoggedIn, metadata, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _magic = magic ||
                            new Magic(appEnv.blockchain.magicLinkApiKey, {
                                network: appEnv.isLive
                                    ? 'mainnet'
                                    : {
                                        rpcUrl: 'https://rpc2.sepolia.org',
                                        chainId: 11155111,
                                    },
                            });
                        setMagic(_magic);
                        return [4 /*yield*/, ((_b = _magic.user) === null || _b === void 0 ? void 0 : _b.isLoggedIn())];
                    case 1:
                        isLoggedIn = (_c.sent());
                        if (!isLoggedIn) return [3 /*break*/, 3];
                        return [4 /*yield*/, _magic.user.getInfo()];
                    case 2:
                        _a = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = undefined;
                        _c.label = 4;
                    case 4:
                        metadata = _a;
                        if (!(!(metadata === null || metadata === void 0 ? void 0 : metadata.publicAddress) || metadata.publicAddress.toLowerCase() !== (userAddress === null || userAddress === void 0 ? void 0 : userAddress.toLowerCase()))) return [3 /*break*/, 6];
                        return [4 /*yield*/, _magic.user.logout()];
                    case 5:
                        _c.sent();
                        setIsMagicLoggedIn(false);
                        setIsMagicLoggedInWithUser(false);
                        return [2 /*return*/];
                    case 6:
                        setIsMagicLoggedIn(isLoggedIn);
                        setIsMagicLoggedInWithUser(Boolean(isLoggedIn && userAddress));
                        return [2 /*return*/];
                }
            });
        });
    }
    function loginWithMagicLink(email) {
        var _this = this;
        if (!magic) {
            throw new Error('[loginWithMagicLink] Magic is undefined.');
        }
        setLoading(true);
        try {
            var handle_1 = magic.auth.loginWithEmailOTP({ email: email, showUI: false, deviceCheckUI: false });
            setErrorMessage(undefined);
            return new Promise(function (resolve, reject) {
                handle_1
                    .on('device-verification-email-sent', function () {
                    setShowDeviceMessage(true);
                })
                    .on('email-otp-sent', function () { return __awaiter(_this, void 0, void 0, function () {
                    var code;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                setLoading(false);
                                setShowOtpDialog(true);
                                setShowDeviceMessage(false);
                                code = '';
                                _b.label = 1;
                            case 1:
                                if (!(code.length === 0)) return [3 /*break*/, 3];
                                code = ((_a = window.document.querySelector('#magic-link-otp-code')) === null || _a === void 0 ? void 0 : _a.innerHTML) || '';
                                return [4 /*yield*/, sleep(1000)];
                            case 2:
                                _b.sent();
                                return [3 /*break*/, 1];
                            case 3:
                                setLoading(true);
                                handle_1.emit('verify-email-otp', code);
                                return [2 /*return*/];
                        }
                    });
                }); })
                    .on('invalid-email-otp', function () {
                    // handle error
                    setLoading(false);
                    setShowOtpDialog(false);
                    setErrorMessage(t('error.magic-link.invalid-email-otp'));
                    handle_1.emit('cancel');
                    reject();
                })
                    .on('done', function (did) {
                    setLoading(false);
                    setShowOtpDialog(false);
                    setErrorMessage(undefined);
                    resolve(did);
                })
                    .on('error', function (reason) {
                    // is called if the Promise rejects
                    setLoading(false);
                    setShowOtpDialog(false);
                    setErrorMessage((reason === null || reason === void 0 ? void 0 : reason.length) > 0 ? reason : t('error.magic-link.generic'));
                    reject();
                });
            });
        }
        catch (err) {
            if (err instanceof Error) {
                console.log(err.message);
            }
        }
        throw new Error('[loginWithMagicLink] login failed.');
    }
    return {
        magic: magic,
        isMagicLoggedIn: isMagicLoggedIn,
        isMagicLoggedInWithUser: isMagicLoggedInWithUser,
        reconnectMagicLink: reconnectMagicLink,
        loginWithMagicLink: loginWithMagicLink,
        showOtpDialog: showOtpDialog,
        showDeviceMessage: showDeviceMessage,
        loading: loading,
        errorMessage: errorMessage,
    };
}
